import React from 'react';
import { useNavigate } from 'react-router-dom';

function SampleTable({ data }) {
  const navigate = useNavigate();

  const editBooking = (record) => {
    navigate(`/bookings/edit/${record.booking_id}`);
  };

  const getRecords = () => {
    const rows = data;
    return rows.map((record, index) => (
      <tr key={record.booking_id + '_' + record.sample_id}>
        <td data-label='S. No.'>{index + 1}</td>
        <td data-label='BOOKING ID'>{record.booking_id}</td>
        <td data-label='SAMPLE ID'>{record.sample_id.toUpperCase()}</td>
        <td data-label='SAMPLE NO'>
          {record.sample_no}
        </td>
        <td data-label='FARM NAME'>{record.farm_name?.toUpperCase() || '-'}</td>
        <td data-label='FARM SIZE'>
          {record.farm_size?.toUpperCase() || '-'}&nbsp;
          {record.farm_size_unit?.toUpperCase() || '-'}
        </td>
        <td
          className='d-block d-sm-block d-md-none d-lg-table-cell'
          data-label='PREVIOUS CROP'
        >
          {record.previous_crop?.toUpperCase() || '-'}
        </td>
        <td
          className='d-block d-sm-block d-md-none d-lg-table-cell'
          data-label='NEXT CROP'
        >
          {record.next_crop?.toUpperCase() || '-'}
        </td>
        <td data-label='TREATMENT'>
          {record.comments ? record?.treatment?.toUpperCase() : 'NA'}
        </td>
        <td data-label='COMMENTS'>
          {record.comments ? record?.comments?.toUpperCase() : '-'}
        </td>
        <td data-label='TEST STATUS'>
          {record.sample_status === 'S'
            ? 'SUBMITTED'
            : record.sample_status === 'I'
              ? 'IN-PROGRESS'
              : record.sample_status === 'C'
                ? 'COMPLETED'
                : ''}
        </td>
        <td data-label='DATE'>
          {' '}
          {new Date(Date.parse(record.created_at)).toDateString()}{' '}
        </td>
        <td>
          <button
            className='btn btn-sm btn-primary'
            onClick={() => editBooking(record)}
          >
            Edit
          </button>
        </td>
      </tr>
    ));
  };

  return (
    <table
      className={`table table-striped text-center table-borderless ${
        data.length > 1 ? 'align-middle' : ''
      }`}
    >
      <thead className='table-dark align-top'>
        <tr>
          <th>S. No.</th>
          <th>BOOKING ID</th>
          <th>SAMPLE ID</th>
          <th>SAMPLE NO</th>
          <th>FARM NAME</th>
          <th>FARM SIZE</th>
          <th className='d-block d-sm-block d-md-none d-lg-table-cell'>
            PREVIOUS CROP
          </th>
          <th className='d-block d-sm-block d-md-none d-lg-table-cell'>
            NEXT CROP
          </th>
          <th>TREATMENT</th>
          <th>COMMENTS</th>
          <th>TEST STATUS</th>
          <th>DATE</th>
          <th>ACTIONS</th>
        </tr>
      </thead>
      <tbody>
        {data && data.length > 0 ? (
          getRecords()
        ) : (
          <tr>
            <td className='no-entries' colSpan='13'>
              No Entries Found..
            </td>
          </tr>
        )}
      </tbody>
    </table>
  );
}

export default SampleTable;